module.exports = __webpack_public_path__ + "img/symbol_12.58f5f28d.png";